export const SET_USER = 'SET_USER';
export const SET_FIRST_LOGIN = 'SET_FIRST_LOGIN';
export const SET_NEED_CRED = 'SET_NEED_CRED';
export const SET_TOKEN = 'SET_TOKEN';
export const SET_LOADING = 'SET_LOADING';
export const SET_CRED = 'SET_CRED';
export const SET_CRED_LOADING = 'SET_CRED_LOADING';